// Port of api/fuel/app/classes/filter/search/games/rules/query/collection_added.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'collection_added',
	field: function() { return 'c.collection_date_owned' }
})
